Object.assign = require('object-assign');


// WEBPACK FOOTER //
// ./polyfills.js